<template lang="pug">
div(:class="css")
  .match-info-wrapper
    template(v-if="countDown > 0")
      div(:class="part1css").blink
        small {{ part1 }}
    template(v-else)
      div(:class="part1css") {{ part1 }}
    .font-weight-bold.score {{ part2 }}
</template>

<script>
import config from "@/config";

export default {
  components: {},
  props: {
    mode: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object
    }
  },
  data() {
    return {
      countDown: 0,
      ticker: null
    };
  },
  computed: {
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    css() {
      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[8] : this.source.runningTime;
      if (mt < 3) {
        return "match-info-date";
      } else {
        return label != null ? (label.trim().length > 0 ? "match-info-score" : "match-info-date") : "match-info-date";
      }
    },
    part1css() {
      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[7] : this.source.runningTime;
      if (mt < 3) {
        return "";
      } else {
        return label != null ? (label.trim().length > 0 ? "time" : "") : "";
      }
    },
    part2() {
      var mdate =  this.mode ? this.$dayjs(this.source.match[8]).format("MM/DD") : this.$dayjs(this.source.matchTime).format("MM/DD");
      var mtime =  this.mode ? this.$dayjs(this.source.match[8]).format("HH:mm") : this.$dayjs(this.source.matchTime).format("HH:mm");

      // if(['MMK','MMO'].includes(this.$store.getters.currencyCode)) {
      //   mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("MM/DD");
      //   mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("HH:mm");
      // }

      switch (this.currency_code) {
        case "MMK":
        case "MMO":
          mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("MM/DD");
          mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("HH:mm");
          break;
        case "NGN":
          mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(420, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(420, 'minute').format("MM/DD");
          mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(420, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(420, 'minute').format("HH:mm");
          break;
      }

      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var score = this.mode ? this.source.match[11] : this.source.runningScore;
      var label = this.mode ? this.source.match[12] : this.source.runningTime;
      if (mt < 3) {
        return mtime;
      } else {
        if (label != null) {
          if (label.trim().length > 0) {
            return score != null ? (score.trim().length > 0 ? score.trim() : mdate) : mdate;
          } else {
            return mdate;
          }
        } else {
          return mdate;
        }
      }
    },
    part1() {
      var mdate =  this.mode ? this.$dayjs(this.source.match[8]).format("MM/DD") : this.$dayjs(this.source.matchTime).format("MM/DD");
      var mtime =  this.mode ? this.$dayjs(this.source.match[8]).format("hh:mm") : this.$dayjs(this.source.matchTime).format("hh:mm");

      // if(['MMK','MMO'].includes(this.$store.getters.currencyCode)) {
      //   mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("MM/DD");
      //   mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("HH:mm");
      // }

      switch (this.currency_code) {
        case "MMK":
        case "MMO":
          mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("MM/DD");
          mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(90, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(90, 'minute').format("HH:mm");
          break;
        case "NGN":
          mdate = this.mode ? this.$dayjs(this.source.match[8]).subtract(420, 'minute').format("MM/DD") : this.$dayjs(this.source.matchTime).subtract(420, 'minute').format("MM/DD");
          mtime = this.mode ? this.$dayjs(this.source.match[8]).subtract(420, 'minute').format("HH:mm") : this.$dayjs(this.source.matchTime).subtract(420, 'minute').format("HH:mm");
          break;
      }

      var mt = this.mode ? this.source.match[4] : this.source.marketId;
      var label = this.mode ? this.source.match[12] : this.source.runningTime;
      if (mt < 3) {
        return mdate;
      } else {
        return label != null ? (label.trim().length > 0 ? this.getLabel(label) : mtime) : mtime;
      }
    }
  },
  destroyed() {
    if (this.ticker) {
      clearTimeout(this.ticker);
    }
  },
  mounted() {
    if (this.source) {
      if (this.isEFight(this.source) && this.source.marketId == 3) {
        this.getCountDown();
      }
    }
  },
  methods: {
    isEFight(e) {
      if (e) {
        return config.isEFight(e.sportsId);
      } else {
        return false;
      }
    },
    getCountDown() {
      this.ticker = setTimeout(() => {
        this.countDown = this.$dayjs(this.source.matchTime).add(10, "s").diff(this.$dayjs(), "s");
        if (this.countDown >= 0) {
          this.getCountDown();
        }
      }, 1000);
    },
    getStyle(e) {
      switch (e) {
        case "LIVE":
          return "danger";
          break;
        case "HT":
          return "info";
          break;
        case "DELAYED":
        case "PEN":
          return "warn";
          break;
        default:
          return "label";
          break;
      }
    },
    getLabel(e) {
      if (/\d/.test(e)) {
        return e.trim();
      } else {
        return this.$tc("m.BT_" + e.trim(), 1);
      }
    }
  }
};
</script>